export const categories = [
  {
    name: "Shoes",
    slug: "shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    icon: "ri-footprint-line",
    items: 128,
    description: "Trending sneakers, boots, and casual footwear sourced from top China suppliers.",
  },
  {
    name: "Hoodies & Sweaters",
    slug: "hoodies-sweaters",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    icon: "ri-t-shirt-line",
    items: 94,
    description: "Cozy hoodies and knitwear with premium fabric blends at unbeatable prices.",
  },
  {
    name: "T-Shirts",
    slug: "t-shirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    icon: "ri-checkbox-blank-circle-line",
    items: 156,
    description: "Graphic tees, basics, and streetwear staples updated weekly in our spreadsheet.",
  },
  {
    name: "Jackets",
    slug: "jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    icon: "ri-shirt-line",
    items: 73,
    description: "Bombers, denim jackets, and winter coats curated from verified manufacturers.",
  },
  {
    name: "Pants & Shorts",
    slug: "pants-shorts",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    icon: "ri-pantone-line",
    items: 88,
    description: "Cargo pants, jeans, and summer shorts with detailed sizing in every listing.",
  },
  {
    name: "Headwear",
    slug: "headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    icon: "ri-shield-user-line",
    items: 42,
    description: "Beanies, caps, and bucket hats — streetwear essentials for every season.",
  },
  {
    name: "Sets",
    slug: "sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    icon: "ri-stack-line",
    items: 36,
    description: "Matching two-piece outfits and coordinated sets for effortless styling.",
  },
  {
    name: "Underwear & Underpants",
    slug: "underwear",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    icon: "ri-heart-line",
    items: 55,
    description: "Comfortable basics and designer-inspired undergarments at wholesale value.",
  },
  {
    name: "Jersey",
    slug: "jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    icon: "ri-football-line",
    items: 67,
    description: "Sports jerseys and athletic wear with authentic stitching and breathable fabrics.",
  },
  {
    name: "Accessories",
    slug: "accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    icon: "ri-sun-line",
    items: 103,
    description: "Sunglasses, watches, jewelry, and small leather goods to complete any outfit.",
  },
  {
    name: "Bags",
    slug: "bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    icon: "ri-briefcase-line",
    items: 59,
    description: "Backpacks, totes, and crossbody bags with premium hardware and stitching.",
  },
  {
    name: "Belts",
    slug: "belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    icon: "ri-link",
    items: 31,
    description: "Leather belts, designer-style buckles, and casual woven options.",
  },
  {
    name: "Perfumes",
    slug: "perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    icon: "ri-drop-line",
    items: 44,
    description: "Designer-inspired fragrances with long-lasting formulas at fraction prices.",
  },
  {
    name: "Other Stuff",
    slug: "other-stuff",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    icon: "ri-more-line",
    items: 82,
    description: "Home goods, gadgets, and unique finds that don't fit traditional categories.",
  },
];